"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var ScoreError = function ScoreError() {
  return React.createElement("div", {
    className: 'd-block text-center mt-3 mb-5'
  }, React.createElement("i", {
    className: 'm-2 fas fa-3x fa-exclamation-triangle'
  }), React.createElement("div", null, "These scores are temporarily unavailable. Please check back soon."));
};
exports.ScoreError = ScoreError;